'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _LikertRenderer = require('./visualizations/LikertRenderer');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// adapte from _.js
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
var DOMContainer = function (_React$Component) {
  _inherits(DOMContainer, _React$Component);
  function DOMContainer(props) {
    _classCallCheck(this, DOMContainer);
    var _this = _possibleConstructorReturn(this, (DOMContainer.__proto__ || Object.getPrototypeOf(DOMContainer)).call(this, props));
    var scale = props.scale,
      options = props.options;
    var renderer = props.renderer || _LikertRenderer.renderLikert;
    _this.CellRenderer = renderer(function () {
      return _this.container;
    }, {
      scale: scale,
      options: options
    });
    return _this;
  }
  _createClass(DOMContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var children = this.props.children;
      var CellRenderer = this.CellRenderer;
      return _react2.default.createElement('div', {
        style: {
          position: 'relative'
        },
        ref: function ref(elem) {
          _this2.container = elem;
        }
      }, children(CellRenderer));
    }
  }]);
  return DOMContainer;
}(_react2.default.Component);

/**
 * simple key increment used to force complete redraw on screen resize
 */

var ScreenResizeWrapper = function (_React$Component2) {
  _inherits(ScreenResizeWrapper, _React$Component2);
  function ScreenResizeWrapper(props) {
    _classCallCheck(this, ScreenResizeWrapper);
    var _this3 = _possibleConstructorReturn(this, (ScreenResizeWrapper.__proto__ || Object.getPrototypeOf(ScreenResizeWrapper)).call(this, props));
    _this3.state = {
      key: 0
    };
    _this3.getOptions = function () {
      // if smallOptions & smallBreakpoint, check size
      var _this3$props = _this3.props,
        smallOptions = _this3$props.smallOptions,
        smallBreakpoint = _this3$props.smallBreakpoint,
        options = _this3$props.options;
      return smallOptions && smallBreakpoint ? typeof window !== "undefined" && window.innerWidth < smallBreakpoint ? _extends({}, options, smallOptions) : options : options;
    };
    _this3.forceResizing = function () {
      return _this3.setState(function (state) {
        return {
          key: state.key + 1
        };
      });
    };
    _this3.resize = debounce(_this3.forceResizing, 100);
    return _this3;
  }
  _createClass(ScreenResizeWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.resize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.getOptions();
      return _react2.default.createElement(DOMContainer, _extends({
        key: this.state.key
      }, this.props, {
        options: options
      }));
    }
  }]);
  return ScreenResizeWrapper;
}(_react2.default.Component);
exports.default = ScreenResizeWrapper;